import { useCallback, useLayoutEffect } from 'react';
import { useRef } from 'react';

/**
 * https://github.com/reactjs/rfcs/blob/useevent/text/0000-useevent.md
 *
 * The callback returned from this hook MUST be used ONLY in a useEffect
 * and ONLY in the same component that it was created in
 */
export function useEventCallback(handler) {
  'use memo';

  const handlerRef = useRef(undefined);

  // Setting this in a layoutEffect is safe as long as this hook is only used locally in this component
  // See https://github.com/reactjs/rfcs/blob/useevent/text/0000-useevent.md#:~:text=The%20%22current%22%20version%20of%20the%20handler%20is%20switched%20before%20all%20the%20layout%20effects%20run
  useLayoutEffect(() => {
    handlerRef.current = handler;
  });
  return useCallback((...args) => {
    const fn = handlerRef.current;
    return fn === null || fn === void 0 ? void 0 : fn(...args);
  }, []);
}